import React from "react";
import styles from "./Header2.module.css";

interface Header2Props {
    className?: string;
    children: React.ReactNode;
}

const Header2: React.FC<Header2Props> = ({ children, className }) => {
    return (
        <h2 className={`${styles.header2} ${className || ""}`}>
            {children}
        </h2>
    );
};

export default Header2;
